<template>
  <b-modal
    id="modal-batch-remove-closed-dates"
    ref="modal"
    title="Batch Remove Closed Dates"
    no-close-on-backdrop
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-variant="primary primary-btn"
    ok-title="Remove"
    cancel-title="Close"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group class="mt-2">
        <p class="report-label mb-2">
          Closed Dates(format: 2024-01-01)
        </p>
        <b-form-input
          v-model="datesClosed"
          type="text"
          placeholder="Enter New Closed Dates"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group class="mt-2">
        <p class="text-danger">
          {{ message }}
        </p>
      </b-form-group>
    </form>
  </b-modal>
</template>
<script>
export default {
  props: ["zoneOptions"],
  name: "remove-town-popup",
  data() {
    return {
      datesClosed: "",
      message: "",
      alert: {
        status: false,
        color: "",
        message: ""
      }
    };
  },
  computed: {},
  methods: {
    show() {
      this.$refs.modal.show();
    },
    checkFormValidity() {
      //validate code
      if (!this.datesClosed || this.datesClosed.length === 0) {
        this.message = "Please Input Closed Dates";
        console.log(this.message);
        this.$emit("warning", this.message);
        return false;
      }
      this.message = "";
      return true;
    },
    resetModal() {
      this.datesClosed = "";
    },
    async handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      await this.handleSubmit();
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      try {
        if (!this.checkFormValidity()) {
          return;
        }

        console.log(process.env.VUE_APP_API_ADMIN_API_ENDPOINT);
        const response = await this.axios.put(
          `${process.env.VUE_APP_API_ADMIN_API_ENDPOINT}/dates-closed-api`,
          {
            dates_closed: this.datesClosed
          }
        );

        this.$nextTick(() => {
          this.$bvModal.hide("modal-batch-remove-closed-dates");
        });
        this.$emit("success", "success");
      } catch (errorResponse) {
        console.log(errorResponse);
        this.$emit("error");
        console.error("Error: ", errorResponse);
      }
    }
  }
};
</script>
